import { render, staticRenderFns } from "./video_13.vue?vue&type=template&id=3c73a23d&scoped=true&"
var script = {}
import style0 from "./video_13.vue?vue&type=style&index=0&id=3c73a23d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c73a23d",
  null
  
)

export default component.exports